import PropTypes from 'prop-types';
import { BsBuilding } from 'react-icons/bs';

const fmt = (value) => (value ?? 0).toLocaleString('de-DE');

/**
 * The result of a round: counts in the header, the free ten-company preview (name and place,
 * never more before the list is open), the rest after saving.
 */
const ResultsBlock = ({ result, preview }) => {
	const rows = (preview ?? []).slice(0, 5);
	return (
		<div className="overflow-hidden rounded-card border border-bgBase-500 bg-white">
			<div className="flex items-center gap-2 border-b border-bgBase-400 px-3.5 py-2.5">
				<BsBuilding className="h-4 w-4 text-primary-600" />
				<span className="text-sm font-semibold text-text">{fmt(result.companies)} Firmen</span>
				{result.qualification && (
					<span className="text-xs text-bgBase-800">
						· davon {fmt(result.qualification.fit)} geprüft passend
						{result.qualification.unchecked > 0
							? ` · ${fmt(result.qualification.unchecked)} ungeprüft`
							: ''}
					</span>
				)}
				{result.contacts > 0 && (
					<span className="text-xs text-bgBase-800">
						· {fmt(result.contacts)} Kontakte{result.emails ? ` · ${fmt(result.emails)} E-Mails` : ''}
					</span>
				)}
				{result.bySource?.maps > 0 && (
					<span className="text-xs text-bgBase-800">· {fmt(result.bySource.maps)} aus Google Maps</span>
				)}
				<span className="ml-auto text-xs text-bgBase-700">Vorschau</span>
			</div>
			{rows.map((company) => (
				<div
					key={company.companyId}
					className="flex items-center gap-3 border-b border-bgBase-300 px-3.5 py-2 last:border-0"
				>
					<div className="min-w-0 flex-1">
						<div className="truncate text-sm text-text">{company.name}</div>
						<div className="truncate text-xs text-bgBase-800">
							{[company.city, company.legalForm].filter(Boolean).join(' · ')}
						</div>
					</div>
				</div>
			))}
			<div className="bg-bgBase-200 px-3.5 py-2 text-xs text-bgBase-800">
				{result.companies > rows.length ? `+${fmt(result.companies - rows.length)} weitere · ` : ''}vollständig
				nach dem Speichern in der Lead-Tabelle
			</div>
		</div>
	);
};

ResultsBlock.propTypes = {
	result: PropTypes.shape({
		companies: PropTypes.number,
		contacts: PropTypes.number,
		emails: PropTypes.number,
		bySource: PropTypes.object,
		qualification: PropTypes.shape({ fit: PropTypes.number, unchecked: PropTypes.number }),
	}).isRequired,
	preview: PropTypes.array,
};

export default ResultsBlock;
